import React from 'react';

import _ from 'lodash';
import cx from 'classnames';

import styles from './properties.module.scss';
import Tooltip from 'components/Tooltip';

function WidgetAction({ icon, tooltip, children, onClick, ...rest }) {
  const action = (
    <button className={cx(styles.action, rest.className)} onClick={(e) => {
      if (onClick) {
        onClick(e);
      }
    }}>
      {children}
    </button>
  );

  if(tooltip){
    return (
      <Tooltip placement={'top'} content={tooltip}>
        {action}
      </Tooltip>
    );
  }

  return action;
}

function WidgetDivider({ icon, tooltip, children, onClick, ...rest }) {
  return (
    <div className={cx(styles.divider, rest.className)}></div>
  );
}

const WidgetActions = {
  Action: WidgetAction,
  Divider: WidgetDivider
}

export default WidgetActions;